// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__iqz3z","header":"Messages_header__3x7jr"};